export default {"src":"/_next/static/media/return.4edbc148.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};